export default __webpack_public_path__ + "static/media/Akhlak-Hossain-Jim-Project-Portfolio-2-960.56f7432b.webp";